import ModuleConfig from '@/config/modules.config';
import { Actions, Mutations } from '@/config/store.config';
import AppConfig from '@/models/appconfig/appconfig.model';
import i18n, { Language, normalizeLanguage } from '@/locales';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

export interface LanguageConfiguration {
  appConfig: AppConfig;
  reset?: boolean;
}

@Module
export default class LanguageModule extends VuexModule {
  language: Language = 'es';
  defaultLanguage: Language = 'es';
  languageSelectionEnabled = false;

  get currentLanguage(): Language {
    return this.language;
  }

  get kioskDefaultLanguage(): Language {
    return this.defaultLanguage;
  }

  get isLanguageSelectionEnabled(): boolean {
    return this.languageSelectionEnabled;
  }

  @Mutation
  [Mutations.SET_LANGUAGE](language: Language): void {
    this.language = language;
    i18n.global.locale.value = language;
    document.documentElement.lang = language;
  }

  @Mutation
  [Mutations.SET_DEFAULT_LANGUAGE](language: Language): void {
    this.defaultLanguage = language;
  }

  @Mutation
  [Mutations.SET_LANGUAGE_SELECTION_ENABLED](enabled: boolean): void {
    this.languageSelectionEnabled = enabled;
  }

  @Action
  [Actions.SET_LANGUAGE](language: string): void {
    this.context.commit(Mutations.SET_LANGUAGE, normalizeLanguage(language));
  }

  @Action
  [Actions.CONFIGURE_LANGUAGE]({
    appConfig,
    reset = true,
  }: LanguageConfiguration): void {
    const defaultLanguage = normalizeLanguage(
      appConfig.moduleOption(ModuleConfig.DEFAULT_LANGUAGE)
    );
    this.context.commit(Mutations.SET_DEFAULT_LANGUAGE, defaultLanguage);
    this.context.commit(
      Mutations.SET_LANGUAGE_SELECTION_ENABLED,
      appConfig.isModuleEnabled(ModuleConfig.LANGUAGE_SELECTION_ENABLED)
    );
    if (reset) {
      this.context.commit(Mutations.SET_LANGUAGE, defaultLanguage);
    }
  }
}
